interface NoResultsProps extends React.HTMLAttributes<HTMLDivElement>, React.HTMLAttributes<HTMLDivElement> {
  message: React.ReactNode;
  button?: React.ReactNode;
}

export const NoResults = ({ message, button, ...props }: NoResultsProps) => {
  return (
    <div
      data-testid="no-results-container"
      className="w-full flex flex-col items-center justify-center gap-y-3"
      {...props}
    >
      <p data-testid="no-results-message" className="typo-primary-500 text-secondary-text">
        {message}
      </p>
      {button}
    </div>
  );
};
